export const MAX_TABS_COUNT = 20;
